import React from 'react';
import './projects.css'
import NavBar from '../../componets/navbar/navbar.js'
import Grid from '@material-ui/core/Grid';
import ProjectCard from '../../componets/projectCard/projectCard';
import { getProjects } from '../../services/contentService';



class Projects extends React.Component {
    
    constructor(props) {
        super(props);

        this.state={ projects:[], loading:true}
    }


    async componentDidMount(){
            try {
                const projects = await getProjects();
                this.setState({projects,loading:false});
            } catch (_) {
                this.setState({projects:[], loading:false});
            }

    };


    getloading(){
        return(
               <div className='projects-loader'>
                 <div className='projects-spinner'></div>
               </div>
        );
       }

       getGrid(){
        return(
            <Grid container className='gridList' alignItems="center"
            alignContent='space-between'>
                   {this.state.projects.map(project =>(<Grid item key={project.slug} className='project-grid' xs={6} sm={4}  md={3} lg={3} ><ProjectCard className='pg-card' project={project}/></Grid>))}
         
               </Grid>
        )
       }

    render () {
      const response = this.state.loading?this.getloading():this.getGrid();
        return (
            <div className='projects'>
            <NavBar/>
            <div className='title'>
                Works
            </div>
            <div>
                {response}
            </div>
           
    </div>


 );
    }
}

export default (Projects);